import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width:'200',
    navigate: true,
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width:'200'
  },
  {
    title: 'Builder Job Number',
    field: 'jobNumber',
    filter: 'text',
    searchable: true,
    width:'200'
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    searchable: true,
    width:'250',
  },
  {
    title: 'Building Permit#',
    field: 'buildingPermit',
    filter: 'text',
    searchable: true,
    width:'180',
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    width:'250',
    searchable: true,
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    width:'250',
    searchable: true,
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    width:'250',
    searchable: true,
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    width:'150',
    searchable: true,
  },
  {
    title: 'Project Type',
    field: 'projectType',
    filter: 'text',
    width:'150',
    searchable: true,
  },
  {
    title: 'Community Type',
    field: 'communityType',
    filter: 'text',
    width:'150',
    searchable: true,
  },
  {
    title: 'Building',
    field: 'buildingName',
    filter: 'text',
    width:'150',
    searchable: true,
  },
  {
    title: 'Fee Owner',
    field: 'feeOwner',
    filter: 'text',
    width:'150',
    searchable: true,
  },
  {
    title: 'Floor',
    field: 'floor',
    filter: 'numeric',
    width:'100',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    width:'100',
    searchable: true,
  },
  {
    title: 'Work Orders',
    field: 'workOrderCount',
    filter: 'numeric',
    width:'150',
    searchable: true,
  },
];
